
import React from 'react';
import '../QueryResults.css'; 

const ONCRP_TOOLS_QP_Card = ({ title, icon, children, className = '' }) => (
    <div className={`ONCRP-TOOLS-QP-card ${className}`}>
        <div className="ONCRP-TOOLS-QP-card-header">
            <i className={`fas ${icon}`}></i>
            <h3>{title}</h3>
        </div>
        <div className="ONCRP-TOOLS-QP-card-body">
            {children}
        </div>
    </div>
);

export default ONCRP_TOOLS_QP_Card;